import React from 'react';
import { Link } from "react-router-dom"
import { Card, Typography } from 'antd';
import PremiseDetailStyle from "./PremiseDetailStyle";

const PremisesDetail = ({ premises, isSearchResult, index }) => {
  const s = PremiseDetailStyle();
  return (
    <Link to={`/detail/${premises.Id}`} style={{ textDecoration: 'none' }} state={{ from: isSearchResult ? "search" : "shameList" }}>
      <Card
      type="inner"
        hoverable
        style={s.Component}
        title="Premise"
      >
        <Typography.Title level={4}>
          {premises.Name.replace(/\w+/g, function (w) { return w[0].toUpperCase() + w.slice(1).toLowerCase(); })}
        </Typography.Title>        
        <Typography>
          {premises.Address ? premises.Address.replace(/\w+/g, function (w) { return w[0].toUpperCase() + w.slice(1).toLowerCase(); }) : "Unknown Address"}
        </Typography>
      </Card>
    </Link>
  );
};
export default PremisesDetail;

